<template>
  <div
    v-if="vacationObj && vacationTypes[vacationObj.type]"
    class="table__cell-vacation"
  >
    <div class="vacation-letter">
      {{ vacationTypes[vacationObj.type].letter }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { vacationTypes } from "@/utils/vacation";
import { VacationItem } from "@/types";

interface Props {
  vacationObj: VacationItem | undefined;
}

defineProps<Props>();
</script>

<style lang="scss">
.vacation-letter {
  font-family: "Montserrat", Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 34px;
  line-height: 41px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #333333;
}

.print-table td .vacation-letter {
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  display: block;
}
</style>